import React from 'react';
import Head from 'next/head';
import YouTubePlayer from 'react-youtube';
import Layout from '../components/layout';
import Container from '../components/container';
import NavBar from '../components/navbar';
import Date from './date';
import Icon from './icon/Icon';
import config from '../lib/config';

import { ISponsor } from '../models/sponsor';
import { IMenuItem } from '../models/menu-item';
import { IPostDirect } from '../models/post';
import { H3, Muted } from './text';
import { useRouter } from 'next/router';

interface IProps {
	data: IPostDirect;
	primaryMenuItems: IMenuItem[];
	sponsors: ISponsor[];
}

const opts = {
	width: '',
	height: '',
};

export default function VideoPage({ data, primaryMenuItems, sponsors }: IProps) {
	const router = useRouter();
	const pageTitle = `${data.title} | ${config.siteName}`;
	const meta = data.seo?.description || data.title;

	return (
		<Layout preview customClass="bg-kkd-dark" sponsors={sponsors} metaTitle={pageTitle} metaDesc={meta}>
			<Head>
				<title>{pageTitle}</title>
			</Head>
			<NavBar items={primaryMenuItems} />
			<Container className="pt-12">
				<article className="pb-12">
					<div className="flex flex-col post-content container mx-auto gap-4 lg:max-w-4xl">
						{data.videoLinks?.youtubeLink && (
							<YouTubePlayer
								iframeClassName="w-full aspect-video"
								videoId={data.videoLinks.youtubeLink}
								opts={opts}
							/>
						)}

						<div className="flex items-center mb-6 cursor-pointer" onClick={() => router.back()}>
							<Icon icon={'arrow-left'} color="#ffffff" size={24} />
							<span className="inline-block ml-3 text-gray-700 hover:text-gray-500 font-inter font-semibold uppercase tracking-widest text-base lg:text-lg">
								Terug
							</span>
						</div>

						<H3 className="text-white mb-1">{data.title}</H3>
						<Muted>
							<Date dateString={data.date} />
						</Muted>
					</div>
				</article>
			</Container>
		</Layout>
	);
}
